import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-accordion';
import '@treasury/presentation/components/tm-card';
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { InformationCenterItemVm } from '../data/information-center-item.vm';

export const tagName = 'information-center-banner';
@customElement(tagName)
export class InformationCenterBanner extends TmBaseComponent {
    @property({ type: Object })
    public message?: InformationCenterItemVm;

    protected render() {
        if (!this.message) {
            return nothing;
        }
        return html`<tm-card class="m-2" .border=${true} .banner=${true}>
            <tm-accordion
                .items=${[
                    {
                        summary: html`${this.message.summary}`,
                        detail: this.message.detail,
                        theme: 'reverse',
                    },
                ]}
            ></tm-accordion>
        </tm-card>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                    --tm-card-min-height: 40px;
                    --tm-card-min-width: auto;
                }
            `,
        ];
    }
}
